import "./styles.sass";
import VPNIcon from "assets/icons/VPN.svg?react";
import useTranslate from "../../../hooks/useTranslate";

type VPNNotificationProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  isVPN: boolean;
};
export const VPNNotification = (props: VPNNotificationProps) => {
  const { isVPN } = props;
  const t = useTranslate();

  return (
    <div className={`VPNBlock ${isVPN ? "show" : "hide"}`}>
      <VPNIcon />
      <div className="VPNBlock__message">{t("casino.notification.vpn")}</div>
    </div>
  );
};
